export default function SelectedItems({ name = '', items, onRemove }) {
  return (
    <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
      <h3
        className={`text-sm font-semibold text-slate-700 ${items.length ? 'mb-2' : ''}`}
      >
        已选择{name} ({items.length})
      </h3>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => (
          <div
            key={item.id}
            className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-700 rounded-md text-xs font-medium"
          >
            <span>{item.name}</span>
            <button
              onClick={() => onRemove(item)}
              className="ml-1 hover:bg-blue-200 rounded-full p-0.5 transition-colors cursor-pointer"
              aria-label="移除机构"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="w-3.5 h-3.5"
              >
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
